import { Internationalization } from '@syncfusion/ej2-base'
import { WebEventDto } from '../types/webTypes/WebEventDto'

// return lowest price and mwst of serminar list
export const useGetMinPrice = (seminarList: WebEventDto[] | undefined): { price: string | undefined; mwStSatz: number | undefined } => {
  if (seminarList === undefined) {
    return { price: undefined, mwStSatz: undefined }
  }

  const fallbackMwstSatz = 19

  const minPrices = seminarList
    .map((seminar) => {
      if (seminar.preis !== null && !isNaN(Number(seminar.preis))) {
        let preis = Number(seminar.preis)
        if (!seminar.mwStpflichtig || seminar.mwStSatz === null) {
          return { price: -1, mwStSatz: seminar.mwStSatz }
        }
        preis += preis * (seminar.mwStSatz / 100)
        return { price: preis, mwStSatz: seminar.mwStSatz }
      }
      return null
    })
    .filter((item) => item !== null)

  if (minPrices[0].price && minPrices[0].mwStSatz) {
    const minPrice = minPrices[0].price
    const mwStSatz = minPrices[0].mwStSatz

    let intl = new Internationalization()
    let nFormatter = intl.getNumberFormat({ format: 'C2', currency: 'EUR' })

    return { price: nFormatter(minPrice), mwStSatz: mwStSatz }
  }

  return { price: '', mwStSatz: fallbackMwstSatz }
}
